var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Stack, Typography, styled } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StableAutocomplete } from '../../common/autocomplete/stable';
import { ReviewMissingDataModal } from './ReviewMissingDataModal';
var StyledTitleBar = styled(Stack)(function (_a) {
  var theme = _a.theme;
  return {
    color: theme.palette.common.white
  };
});
var StyledLocationAutocomplete = styled(StableAutocomplete)(function () {
  return {
    width: '20rem'
  };
});
var MissingDataButton = styled(Button)(function (_a) {
  var theme = _a.theme;
  return {
    color: theme.palette.warning.light,
    textDecoration: 'underline',
    textUnderlineOffset: 2,
    textTransform: 'none',
    gap: theme.spacing(1),
    '&:hover': {
      textDecoration: 'underline'
    }
  };
});
export var ReviewTitleBar = function (_a) {
  var locations = _a.locations,
    selectedLocationId = _a.selectedLocationId,
    onLocationChange = _a.onLocationChange,
    missingData = _a.missingData,
    onNavigateToStep = _a.onNavigateToStep,
    isViewOnly = _a.isViewOnly;
  var t = useTranslation('orgConfig').t;
  var tReview = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.reviewStep'
  }).t;
  var _b = useState(false),
    modalOpen = _b[0],
    setModalOpen = _b[1];
  var locationOptions = locations.map(function (loc) {
    return {
      id: loc.id,
      name: loc.locationName
    };
  });
  return _jsxs(_Fragment, {
    children: [_jsxs(StyledTitleBar, __assign({
      bgcolor: "primary.main",
      padding: 4,
      borderRadius: 1,
      direction: "row",
      alignItems: "center",
      gap: 4
    }, {
      children: [_jsxs(Typography, __assign({
        variant: "subtitle1"
      }, {
        children: [_jsx(FontAwesomeIcon, {
          icon: "location-dot"
        }), "\u00A0\u00A0", t('organization.myOrganization')]
      })), _jsxs(Typography, {
        children: [tReview('location'), ":"]
      }), _jsx(StyledLocationAutocomplete, {
        value: selectedLocationId !== null && selectedLocationId !== void 0 ? selectedLocationId : 0,
        options: locationOptions,
        onChange: function (id) {
          return void onLocationChange(id);
        }
      }), _jsx(Box, __assign({
        marginLeft: "auto"
      }, {
        children: _jsx(MissingDataButton, __assign({
          "data-testid": "missing-data-button",
          startIcon: _jsx(FontAwesomeIcon, {
            icon: ['far', 'magnifying-glass-minus']
          }),
          onClick: function () {
            return setModalOpen(true);
          }
        }, {
          children: tReview('missingDataButton')
        }))
      }))]
    })), _jsx(ReviewMissingDataModal, {
      open: modalOpen,
      onClose: function () {
        return setModalOpen(false);
      },
      missingData: missingData,
      onNavigate: onNavigateToStep,
      isViewOnly: isViewOnly
    })]
  });
};